export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/MyOrder")
  },
  {
    path: "/order/lists",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OfflineOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: true,
      home: false,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/order/status",
    name: "PaymentStatus",
    meta: {
      title: "支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申请退货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  },
  {
    path: "/recede/refund",
    name: "Refund",
    meta: {
      title: "退换货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/Refund.vue")
  },
  {
    path: "/recede/refundmoney",
    name: "Refundmoney",
    meta: {
      title: "退货退款",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/Refundmoney.vue")
  },
  {
    path: "/recede/exchange",
    name: "Refund",
    meta: {
      title: "退换货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/Exchange.vue")
  },
  {
    path: "/recede/refundmoneyinfo",
    name: "Refundmoneyinfo",
    meta: {
      title: "退货信息填写",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/Refundmoneyinfo.vue")
  },
  {
    path: "/recede/exchangeinfo",
    name: "Refundinfo",
    meta: {
      title: "换货信息填写",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/Exchangeinfo.vue")
  },
  {
    path: "/recede/recededetails",
    name: "Recededetails",
    meta: {
      title: "退换货详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/recede/RecedeDetails.vue")
  }
];
